import React from "react";
import { ReactQueryDevtools } from "react-query/devtools";
import { useLocation } from "react-router-dom";

export const DevTools = () => {
  const { search } = useLocation();

  const enableDevTools = React.useMemo(() => {
    const devTools = new URLSearchParams(search).get("devtools");
    return devTools === "true";
  }, [search]);

  if (!enableDevTools) return null;

  return (
    <>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </>
  );
};
